module.exports = __webpack_public_path__ + "h5/img/close.ff3cd2b9.png";